import { Link } from "react-router-dom";
import { recipes } from "../data/recipes";

const SingleServeCookies = () => {
  return (
    <section className="py-24 bg-[#fff9e6]">
      <div className="max-w-7xl mx-auto px-6">

        <h2 className="text-center text-5xl font-serif text-[#7a7a00] mb-16">
          Eggless Single Serve Cookies
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {recipes.slice(4).map((item) => (
            <Link
              key={item.slug}
              to={`/recipes/${item.slug}`}
              className="bg-[#a84f4f] rounded-2xl overflow-hidden"
            >
              <div className="h-[320px]">
                <img src={item.image} className="w-full h-full object-cover" />
              </div>
              <div className="p-6 text-center">
                <p className="text-white font-serif text-lg">
                  {item.title}
                </p>
              </div>
            </Link>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SingleServeCookies;
